import React from 'react';
import ErrorBoundary from '../Components/ErrorBoundary/ErrorBoundary';
import ContextAllPost from './AllPostContext';
import ContextPost from './PostContext';
import ContextLocation from './LocationContext';
import NotificationProvider from './NotificationContext';
import OfferProvider from './OfferContext';
import WatchlistProvider from './WatchlistContext';
import ContextChat from './ChatContext';
import { ToastProvider } from './ToastContext';

function AppProviders({ children }) {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <NotificationProvider>
          <OfferProvider>
            <WatchlistProvider>
              <ContextChat>
                <ContextAllPost>
                  <ContextPost>
                    <ContextLocation>{children}</ContextLocation>
                  </ContextPost>
                </ContextAllPost>
              </ContextChat>
            </WatchlistProvider>
          </OfferProvider>
        </NotificationProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default AppProviders;
